import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  addServiceData: [],
};

export const AddServiceDataSlice = createSlice({
  name: "addServiceData",
  initialState,
  reducers: {
    getAddServiceDataAction: (state, action) => {
      state.addServiceData = action.payload;
    },
  },
});

export default AddServiceDataSlice.reducer;

export const { getAddServiceDataAction } = AddServiceDataSlice.actions;
